const initialState = {
  company_name: ""
};

const CompanyReducer = (state = initialState, action) => {

  switch (action.type) {

    case "SET_COMPANY_NAME":
      return {
        ...state,
        company_name: action.payload
      };

    default:
      return state;
  }
};

export default CompanyReducer;